export default "__VITE_ASSET__CjqMHWrE__"